import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { MainService } from './provider/main.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  expireToken: any;
  token: string | any;
  constructor(
    private router: Router, private service: MainService
  ) {
    this.service.isToken.subscribe((res) => {
      this.expireToken = res;
    })
  }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
    this.expireToken = localStorage.getItem('responseCode') ? localStorage.getItem('responseCode') : this.expireToken;
    if ((this.token == '') || (this.expireToken == 401)) {
      this.service.errorToast('Your token is expired , please login again.');
      localStorage.removeItem('token');
      localStorage.removeItem('responseCode');
      this.service.loginStatus.next(false);
      this.router.navigate(['/login']);

      return false;
    }
    return true;
  }

}
